import { useQuery } from '@tanstack/react-query';
import { getOwnBrandsV2 } from '../api/locations.api';
import { queryKeys } from '../api/queryKeys';
import type { OwnBrandEntity } from '../types/brand.types';

const NO_OWN_BRANDS: OwnBrandEntity[] = [];

/**
 * The location's own brands (RB, VPC, ...), the ones a merchant may edit the
 * menu and hours of. vGrubs virtual brands never appear here, the backend
 * filters them out, so anything picked from this list is safe to write to.
 *
 * Shared by Location Details (the brand cards) and Working Hours (the brand
 * picker), so moving between the two reads one cache entry.
 */
export function useOwnBrands(
  locationId: number | string | null | undefined,
  options: { enabled?: boolean } = {}
) {
  const { enabled = true } = options;

  const query = useQuery({
    queryKey: queryKeys.ownBrands.byLocation(locationId ?? ''),
    queryFn: async () => {
      const { data } = await getOwnBrandsV2(locationId as number | string);
      return data.data;
    },
    enabled: enabled && locationId != null && locationId !== '',
    staleTime: 60 * 1000,
  });

  return {
    /** Always an array - empty until the first response. */
    ownBrands: query.data ?? NO_OWN_BRANDS,
    isLoading: query.isLoading,
  };
}
